export default __webpack_public_path__ + "static/image18-6db1d27493d1e905f8c94b95c2e8bc50.gif";